import { Outlet, createFileRoute } from "@tanstack/react-router";

/**
 * The index (the frameworks list) and the detail pages are this route's
 * children; the parent only has to let them render — without an `Outlet`
 * the child route matches the URL and shows nothing.
 */
export const Route = createFileRoute("/$org/compliance/frameworks")({
  component: Outlet,
});
